import FileMetaDTO from "@/dto/files/FileMetaDTO";

export default class AddForeignIDPayload {
    file: FileMetaDTO | null = null;
    issuedByCountry: string | null = null;
    comment: string | null = null;
}